var SAMSUNG_AR19MRFHPWKN = {
  name: "SAMSUNG AR19MRFHPWKN",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
	    temperature: "AC_TEMP_NULL",
	    fan: "AC_FAN_NULL",
	    command: [93,1,6,28,2,124,1,143,2,107,69,253,11,187,34,33,2,149,5,73,2,72,11,74,2,0,0,76,127,142,35,17,17,31,255,255,255,252,68,36,127,199,24,136,136,143,255,255,255,255,132,143,248,241,17,136,136,136,136,241,17,248,198,56,143,252,68,16,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,28,2,134,1,155,2,87,69,27,12,149,34,43,2,124,5,88,2,70,11,84,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,241,136,255,136,136,130,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,125,1,169,2,100,69,254,11,184,34,26,2,148,5,73,2,74,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,30,60,127,136,136,130,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,28,2,125,1,145,2,95,69,4,12,189,34,23,2,148,5,73,2,71,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,142,60,127,136,136,130,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,27,2,124,1,123,2,99,69,0,12,191,34,25,2,149,5,72,2,72,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,17,199,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [93,1,7,58,2,97,1,150,2,146,69,0,12,155,34,86,2,106,5,33,2,187,1,81,2,49,11,73,2,0,0,76,127,140,35,136,136,143,255,255,195,15,248,136,136,36,127,199,24,136,136,143,252,33,255,255,8,127,130,71,248,71,136,140,68,68,68,71,136,140,48,241,143,30,16,226,34,32,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,41,2,122,1,142,2,105,69,227,11,213,34,27,2,127,5,88,2,75,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,24,199,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,28,2,125,1,146,2,102,69,239,11,208,34,25,2,147,5,73,2,69,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,136,199,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,30,2,121,1,149,2,107,69,229,11,208,34,48,2,129,5,90,2,70,11,85,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,136,199,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,30,2,124,1,149,2,110,69,248,11,190,34,27,2,141,5,97,2,71,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,226,60,127,136,136,130,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,33,2,135,1,154,2,98,69,254,11,184,34,18,2,144,5,74,2,88,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,28,71,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,49,2,120,1,153,2,142,69,1,12,157,34,72,2,107,5,77,2,42,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,140,71,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,33,2,122,1,148,2,109,69,246,11,181,34,43,2,138,5,74,2,68,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,140,71,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,31,2,124,1,146,2,101,69,5,12,189,34,26,2,150,5,74,2,68,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,196,71,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,33,2,124,1,145,2,97,69,2,12,182,34,31,2,142,5,74,2,73,11,79,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,196,71,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,31,2,124,1,153,2,110,69,247,11,190,34,30,2,146,5,86,2,66,11,86,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,68,71,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [93,1,6,28,2,124,1,153,2,112,69,250,11,193,34,28,2,148,5,74,2,65,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,241,140,127,136,136,130,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [93,1,6,33,2,122,1,151,2,111,69,241,11,194,34,24,2,142,5,75,2,62,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,30,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [93,1,6,32,2,123,1,154,2,106,69,251,11,184,34,34,2,130,5,98,2,35,11,96,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,142,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [93,1,6,30,2,123,1,149,2,85,69,30,12,173,34,40,2,138,5,73,2,75,11,76,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,142,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [93,1,6,33,2,124,1,139,2,101,69,4,12,182,34,32,2,132,5,85,2,63,11,87,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,198,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [93,1,6,28,2,122,1,143,2,104,69,251,11,186,34,33,2,130,5,88,2,61,11,95,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,198,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [93,1,6,32,2,122,1,143,2,116,69,241,11,185,34,47,2,132,5,94,2,63,11,85,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,70,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [93,1,6,34,2,123,1,144,2,103,69,254,11,181,34,26,2,127,5,83,2,65,11,93,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,24,198,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [93,1,6,27,2,122,1,158,2,108,69,251,11,192,34,28,2,137,5,84,2,63,11,87,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,226,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [93,1,6,30,2,122,1,147,2,106,69,253,11,192,34,30,2,144,5,74,2,72,11,87,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,226,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [93,1,6,27,2,123,1,169,2,102,69,0,12,199,34,31,2,148,5,71,2,71,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,98,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [93,1,6,30,2,122,1,154,2,109,69,250,11,191,34,36,2,132,5,90,2,74,11,91,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,136,198,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [93,1,6,33,2,124,1,142,2,116,69,245,11,187,34,26,2,146,5,89,2,72,11,89,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,254,34,49,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [93,1,6,31,2,122,1,154,2,111,69,243,11,196,34,30,2,140,5,75,2,69,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,24,136,198,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [93,1,6,30,2,123,1,153,2,102,69,20,12,171,34,50,2,118,5,73,2,68,11,92,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,136,136,198,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [93,1,6,32,2,128,1,149,2,102,69,28,12,155,34,45,2,137,5,74,2,74,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,241,196,127,136,136,130,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [93,1,6,26,2,131,1,124,2,99,69,0,12,187,34,23,2,139,5,75,2,88,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,30,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [93,1,6,30,2,124,1,146,2,99,69,3,12,178,34,31,2,150,5,74,2,68,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,142,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [93,1,6,29,2,123,1,154,2,97,69,251,11,192,34,29,2,147,5,74,2,46,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,142,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [93,1,6,30,2,124,1,175,2,106,69,248,11,183,34,26,2,150,5,74,2,69,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,198,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [93,1,6,30,2,122,1,154,2,98,69,2,12,188,34,34,2,147,5,73,2,70,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,198,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [93,1,6,52,2,123,1,140,2,147,69,0,12,148,34,70,2,119,5,70,2,40,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,70,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [93,1,6,36,2,123,1,142,2,105,69,252,11,167,34,29,2,146,5,74,2,61,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,24,226,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [93,1,6,34,2,122,1,153,2,101,69,254,11,175,34,32,2,135,5,88,2,69,11,91,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,226,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [93,1,6,30,2,122,1,143,2,106,69,17,12,160,34,48,2,135,5,71,2,67,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,226,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [93,1,6,28,2,122,1,151,2,99,69,0,12,185,34,30,2,149,5,73,2,63,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,98,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [93,1,6,40,2,122,1,137,2,104,69,235,11,213,34,28,2,144,5,74,2,61,11,87,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,136,226,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [93,1,6,27,2,124,1,151,2,105,69,247,11,191,34,32,2,137,5,89,2,66,11,84,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,254,34,56,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [93,1,6,34,2,122,1,139,2,107,69,247,11,183,34,41,2,143,5,74,2,71,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,24,136,226,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [93,1,6,26,2,122,1,152,2,101,69,19,12,167,34,46,2,134,5,75,2,66,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,136,136,226,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [93,1,7,27,2,127,1,154,2,103,69,255,11,183,34,24,2,148,5,100,2,95,1,73,2,73,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,130,71,252,113,136,136,136,255,255,255,255,248,36,127,199,24,140,68,68,68,71,136,143,252,70,35,252,68,68,8,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,31,2,126,1,138,2,67,69,24,12,192,34,32,2,149,5,72,2,70,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,241,24,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,29,2,122,1,154,2,107,69,243,11,184,34,52,2,149,5,72,2,71,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,113,24,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,33,2,123,1,153,2,105,69,6,12,169,34,31,2,127,5,75,2,64,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,196,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,24,2,124,1,136,2,6,70,254,11,188,34,28,2,146,5,73,2,70,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,254,49,24,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,29,2,130,1,164,2,103,69,249,11,194,34,19,2,150,5,72,2,91,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,24,196,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,28,2,125,1,142,2,116,69,254,11,182,34,35,2,142,5,73,2,74,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,136,196,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,34,2,122,1,139,2,70,69,46,12,163,34,43,2,117,5,89,2,68,11,88,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,49,136,136,136,136,241,17,248,136,196,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,34,2,120,1,146,2,101,69,248,11,186,34,35,2,146,5,83,2,62,11,87,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,255,17,24,143,241,17,16,64,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,28,2,122,1,153,2,108,69,245,11,198,34,33,2,140,5,88,2,63,11,99,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,28,68,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,54,2,120,1,153,2,94,69,9,12,162,34,63,2,123,5,71,2,63,11,79,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,140,68,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,50,2,121,1,145,2,90,67,2,12,148,34,67,2,119,5,71,2,39,11,49,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,49,136,136,136,136,241,17,248,140,68,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,43,2,122,1,153,2,107,69,5,12,149,34,34,2,140,5,72,2,75,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,196,68,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,35,2,120,1,126,2,107,69,246,11,186,34,30,2,144,5,84,2,74,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,49,136,136,136,136,241,17,248,196,68,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,25,2,128,1,125,2,99,69,13,12,181,34,33,2,139,5,73,2,73,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,49,136,136,136,136,241,17,252,68,68,98,63,196,68,65,0,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,31,2,126,1,152,2,110,69,251,11,181,34,25,2,142,5,75,2,71,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,142,62,63,136,136,130,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,30,2,124,1,149,2,107,69,251,11,180,34,25,2,150,5,74,2,63,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,17,199,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,25,2,125,1,151,2,108,69,18,12,170,34,39,2,139,5,73,2,38,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,198,62,63,136,136,130,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,29,2,122,1,148,2,111,69,15,12,162,34,40,2,134,5,72,2,64,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,24,199,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,30,2,122,1,154,2,105,69,255,11,186,34,24,2,147,5,73,2,67,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,136,199,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,30,2,126,1,153,2,111,69,19,12,167,34,36,2,131,5,76,2,88,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,136,199,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,28,2,127,1,146,2,101,69,25,12,165,34,38,2,137,5,74,2,68,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,226,62,63,136,136,130,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,30,2,124,1,149,2,100,69,25,12,161,34,36,2,138,5,74,2,45,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,28,71,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,126,1,150,2,96,69,4,12,179,34,23,2,149,5,73,2,63,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,140,71,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,29,2,125,1,150,2,100,69,24,12,163,34,35,2,137,5,74,2,62,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,140,71,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,31,2,124,1,145,2,95,69,27,12,161,34,38,2,135,5,73,2,73,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,196,71,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,123,1,169,2,96,69,24,12,158,34,37,2,136,5,73,2,72,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,196,71,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,122,1,148,2,99,69,253,11,184,34,21,2,149,5,74,2,60,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,68,71,199,241,17,16,64,],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [93,1,6,31,2,122,1,152,2,99,69,245,11,187,34,31,2,130,5,87,2,62,11,77,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,255,17,140,71,241,17,16,64,],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [93,1,6,28,2,128,1,151,2,100,69,15,12,162,34,39,2,135,5,74,2,87,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,255,17,196,71,241,17,16,64,],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,31,2,130,1,149,2,105,69,245,11,183,34,20,2,149,5,74,2,88,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,226,35,17,31,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,33,2,128,1,147,2,95,69,0,12,180,34,27,2,148,5,74,2,87,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,68,70,34,34,34,35,196,71,254,63,31,136,136,130,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,31,2,124,1,155,2,98,69,251,11,183,34,21,2,149,5,74,2,62,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,30,63,31,136,136,130,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,30,2,126,1,141,2,102,69,248,11,183,34,26,2,149,5,73,2,73,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,142,63,31,136,136,130,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,56,2,117,1,145,2,139,69,255,11,147,34,73,2,107,5,88,2,40,11,46,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,17,199,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,29,2,121,1,142,2,99,69,255,11,189,34,28,2,133,5,87,2,67,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,198,63,31,136,136,130,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,30,2,123,1,149,2,93,69,3,12,187,34,34,2,148,5,88,2,72,11,80,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,24,199,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,25,2,122,1,151,2,102,69,251,11,194,34,26,2,137,5,74,2,69,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,136,199,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,27,2,123,1,153,2,103,69,249,11,190,34,28,2,147,5,74,2,70,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,136,199,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,23,2,123,1,157,2,104,69,251,11,189,34,28,2,127,5,89,2,73,11,93,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,226,63,31,136,136,130,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,28,2,123,1,148,2,96,69,5,12,190,34,37,2,144,5,73,2,63,11,89,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,28,71,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,120,1,148,2,107,69,249,11,181,34,51,2,134,5,91,2,60,11,92,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,140,71,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,34,2,119,1,153,2,110,69,14,12,159,34,67,2,127,5,89,2,33,11,99,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,140,71,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,31,2,123,1,151,2,101,69,0,12,176,34,35,2,148,5,73,2,70,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,196,71,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,30,2,122,1,151,2,91,69,4,12,187,34,32,2,148,5,74,2,32,11,82,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,196,71,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,123,1,152,2,104,69,251,11,181,34,35,2,147,5,74,2,70,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,68,71,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [93,1,6,30,2,122,1,144,2,102,69,1,12,184,34,32,2,148,5,83,2,61,11,88,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,241,143,31,136,136,130,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [93,1,6,28,2,122,1,172,2,102,69,0,12,186,34,34,2,148,5,75,2,72,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,30,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [93,1,6,34,2,120,1,144,2,109,69,18,12,153,34,45,2,124,5,73,2,65,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,142,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [93,1,6,35,2,120,1,142,2,96,69,9,12,179,34,47,2,135,5,73,2,64,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,142,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [93,1,6,24,2,122,1,146,2,107,69,251,11,189,34,34,2,139,5,74,2,76,11,90,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,198,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [93,1,6,31,2,123,1,127,2,94,69,9,12,174,34,31,2,142,5,75,2,62,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,198,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [93,1,6,28,2,121,1,149,2,101,69,15,12,178,34,37,2,134,5,73,2,68,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,70,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [93,1,6,32,2,120,1,149,2,97,69,8,12,182,34,32,2,146,5,73,2,62,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,24,199,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [93,1,6,36,2,122,1,144,2,105,69,26,12,152,34,54,2,123,5,94,2,74,11,87,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,226,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [93,1,6,38,2,119,1,151,2,117,69,222,11,220,34,27,2,142,5,90,2,70,11,93,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,226,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [93,1,6,28,2,122,1,171,2,99,69,9,12,185,34,33,2,138,5,100,2,61,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,98,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [93,1,6,28,2,122,1,148,2,101,69,1,12,180,34,31,2,136,5,73,2,73,11,88,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,136,199,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [93,1,6,35,2,122,1,154,2,108,69,0,12,176,34,28,2,139,5,86,2,85,11,89,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,254,34,49,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [93,1,6,30,2,122,1,152,2,97,69,5,12,182,34,26,2,149,5,75,2,63,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,24,136,199,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [93,1,6,32,2,122,1,151,2,105,69,26,12,153,34,40,2,132,5,86,2,73,11,87,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,136,136,199,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [93,1,6,33,2,121,1,146,2,80,69,18,12,181,34,55,2,145,5,89,2,66,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,241,199,31,136,136,130,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [93,1,6,30,2,124,1,125,2,100,69,254,11,185,34,23,2,149,5,74,2,60,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,30,56,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [93,1,6,32,2,118,1,229,11,205,34,139,2,100,69,36,2,137,5,85,2,48,11,75,2,0,0,44,127,142,56,136,136,255,255,255,255,136,136,133,31,241,198,34,34,35,255,255,255,255,225,71,252,113,136,196,68,68,68,120,136,254,56,227,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [93,1,6,30,2,121,1,146,2,91,69,4,12,180,34,55,2,144,5,75,2,65,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,142,56,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [93,1,6,41,2,120,1,140,2,110,69,227,11,211,34,36,2,146,5,75,2,60,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,198,56,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [93,1,6,26,2,121,1,153,2,94,69,3,12,190,34,52,2,146,5,73,2,67,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,198,56,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [93,1,6,27,2,122,1,170,2,70,69,26,12,188,34,32,2,149,5,72,2,75,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,70,56,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [93,1,6,31,2,126,1,147,2,92,69,2,12,184,34,20,2,149,5,74,2,65,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,24,227,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [93,1,6,28,2,125,1,155,2,103,69,249,11,192,34,28,2,148,5,73,2,71,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,226,56,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [93,1,6,32,2,122,1,142,2,94,69,3,12,179,34,50,2,150,5,72,2,64,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,226,56,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [93,1,6,31,2,125,1,147,2,98,69,252,11,187,34,30,2,149,5,74,2,62,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,98,56,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [93,1,6,29,2,128,1,147,2,104,69,247,11,189,34,23,2,149,5,73,2,63,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,136,227,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [93,1,6,35,2,124,1,150,2,98,69,15,12,161,34,37,2,136,5,75,2,63,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,254,34,56,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [93,1,6,31,2,124,1,147,2,108,69,244,11,181,34,21,2,149,5,74,2,67,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,24,136,227,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [93,1,6,33,2,122,1,141,2,97,69,2,12,179,34,52,2,150,5,73,2,64,11,87,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,136,136,227,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,33,2,128,1,151,2,68,69,27,12,179,34,24,2,149,5,75,2,88,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,241,24,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,28,2,125,1,175,2,101,69,248,11,185,34,29,2,149,5,73,2,61,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,241,24,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,25,2,126,1,147,2,92,69,4,12,193,34,25,2,149,5,74,2,69,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,113,24,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,28,2,125,1,152,2,93,69,2,12,189,34,24,2,148,5,75,2,72,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,196,99,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,32,2,126,1,143,2,66,69,32,12,179,34,25,2,149,5,73,2,65,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,254,49,24,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,33,2,126,1,149,2,99,69,255,11,181,34,26,2,149,5,72,2,75,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,24,196,99,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,29,2,128,1,155,2,103,69,254,11,188,34,21,2,149,5,74,2,65,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,136,196,99,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,34,2,124,1,149,2,109,69,224,11,207,34,25,2,145,5,73,2,61,11,73,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,49,136,136,136,136,241,17,248,136,196,99,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,31,2,120,1,152,2,99,69,3,12,189,34,46,2,131,5,87,2,71,11,84,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,255,17,24,227,241,17,16,64,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,33,2,121,1,143,2,100,69,254,11,180,34,34,2,146,5,90,2,61,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,28,68,99,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,30,2,121,1,129,2,107,69,246,11,180,34,24,2,149,5,73,2,73,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,140,68,99,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,30,2,121,1,167,2,95,69,4,12,187,34,34,2,142,5,74,2,59,11,77,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,49,136,136,136,136,241,17,248,140,68,99,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,32,2,121,1,146,2,107,69,13,12,155,34,46,2,118,5,91,2,73,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,196,68,99,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,34,2,120,1,179,2,107,69,243,11,181,34,58,2,145,5,91,2,63,11,72,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,49,136,136,136,136,241,17,248,196,68,99,143,196,68,65,0,],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [93,1,6,125,2,66,69,27,2,120,1,29,12,190,34,54,2,131,5,90,2,63,11,85,2,0,0,148,85,85,21,21,17,17,21,85,85,85,85,85,85,85,81,17,16,145,85,85,21,20,68,68,69,85,85,85,85,85,85,85,85,84,36,85,85,69,81,69,17,17,17,17,84,68,85,84,68,68,81,81,85,68,68,65,0,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,25,2,126,1,140,2,93,69,25,12,169,34,40,2,137,5,73,2,76,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,30,34,49,17,17,17,30,34,63,241,136,255,136,136,130,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,31,2,124,1,142,2,181,68,255,11,180,34,23,2,150,5,75,2,60,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,30,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,122,1,152,2,89,69,5,12,179,34,49,2,149,5,82,2,67,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,142,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,124,1,172,2,91,69,28,12,157,34,37,2,140,5,74,2,71,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,142,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,31,2,124,1,151,2,93,69,2,12,183,34,26,2,150,5,75,2,64,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,198,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,26,2,121,1,144,2,109,69,11,12,169,34,43,2,139,5,74,2,72,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,198,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,31,2,124,1,169,2,109,69,13,12,159,34,32,2,141,5,73,2,74,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,70,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,28,2,125,1,146,2,94,69,3,12,192,34,21,2,148,5,76,2,66,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,24,196,127,196,68,65,0,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,28,2,124,1,149,2,89,69,28,12,169,34,30,2,140,5,75,2,66,11,85,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,98,49,17,17,17,30,34,63,226,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,123,1,150,2,99,69,16,12,157,34,44,2,137,5,74,2,68,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,248,226,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,34,2,123,1,152,2,104,69,16,12,156,34,33,2,140,5,75,2,63,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,252,98,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,123,1,148,2,93,69,5,12,185,34,20,2,146,5,75,2,45,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,17,136,196,127,196,68,65,0,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,29,2,123,1,143,2,110,69,13,12,167,34,40,2,141,5,76,2,63,11,75,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,31,17,136,136,136,136,241,17,254,34,49,31,241,17,16,64,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,32,2,122,1,154,2,91,69,7,12,184,34,24,2,144,5,74,2,69,11,76,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,24,136,196,127,196,68,65,0,],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [93,1,6,33,2,122,1,183,2,105,69,19,12,157,34,39,2,138,5,74,2,60,11,74,2,0,0,76,127,142,56,136,136,255,255,255,255,136,136,132,143,248,227,17,17,17,255,255,255,255,240,145,255,28,70,49,17,17,17,30,34,63,136,136,196,127,196,68,65,0,],
    },
  ]
};

export default SAMSUNG_AR19MRFHPWKN
